import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { CaseDetailsContainer } from './v1/index.container';

interface SendReportVersionRouterProps {
  isApplicantSection?: boolean;
}

export const SendReportVersionRouter: React.FC<SendReportVersionRouterProps> = (props) => {
  return (
    <Routes>
      <Route path="v1/*" element={<CaseDetailsContainer isApplicantSection={props.isApplicantSection} />} />
    </Routes>
  );
};

